// ===== CONFIGURACIÓN DE ARCHIVOS DE TRADUCCIÓN =====

/**
 * Lista de archivos de traducción que se cargan en la aplicación.
 *
 * Para agregar un nuevo archivo de traducción:
 * 1. Crear el archivo en: public/assets/i18n/{idioma}/{nombre}.json
 * 2. Agregar el nombre aquí en el array TRANSLATION_FILES
 * 3. El archivo se cargará automáticamente en todos los idiomas configurados
 *
 * Ejemplo:
 * - Archivo: public/assets/i18n/es/nuevo-modulo.json
 * - Archivo: public/assets/i18n/en/nuevo-modulo.json
 * - Agregar: 'nuevo-modulo' a TRANSLATION_FILES
 */
export const TRANSLATION_FILES = [
  'common',    // Traducciones comunes (títulos, botones, mensajes)
  'auth',      // Traducciones de autenticación
  'terms',     // Términos y condiciones
  'invitation', // Traducciones de invitaciones
  'personalInfo' // Traducciones de información personal
] as const;

export enum SupportedLanguages {
  ES = 'es',
  EN = 'en'
}

// Idiomas soportados en la aplicación
export const SUPPORTED_LANGUAGES = [
  SupportedLanguages.ES,
  SupportedLanguages.EN
] as const;

// Idioma por defecto
export const DEFAULT_LANGUAGE = SupportedLanguages.ES as const;

export const HEADER_ACCEPT_LANGUAGE = 'accept-language' as const;

// ===== TIPOS PARA TYPE SAFETY =====
export type TranslationFile = typeof TRANSLATION_FILES[number];
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

